import { COUNTRY_CODE_TO_LANGUAGE } from 'src/app/utils/translate.service';
import dayjs from 'dayjs';

const LOCALE_TO_TIMEZONE: { [locale: string]: string } = {
  'nl-NL': 'Europe/Amsterdam',
  'nl-BE': 'Europe/Brussels',
  'en-GB': 'Europe/London',
  'en-US': 'America/New_York',
  'de-DE': 'Europe/Berlin',
};

export function getTimezoneForLocale(locale?: string): string {
  if (!locale) {
    return 'UTC';
  }

  return LOCALE_TO_TIMEZONE[locale] ?? 'UTC';
}

export function getTimezoneForCountryCode(countryCode?: string, fallbackLocale?: string): string {
  if (!countryCode) {
    return getTimezoneForLocale(fallbackLocale);
  }

  const locale = COUNTRY_CODE_TO_LANGUAGE[countryCode.toLowerCase()];
  return getTimezoneForLocale(locale ?? fallbackLocale);
}

export function toRfc3339FromLocalDate(
  localDate: string,
  timezone: string,
  hour: number,
  minute = 0,
): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(localDate)) {
    throw new Error(`Expected localDate in YYYY-MM-DD format, received: ${localDate}`);
  }

  return dayjs
    .tz(localDate, timezone)
    .set('hours', hour)
    .set('minutes', minute)
    .set('seconds', 0)
    .set('milliseconds', 0)
    .format('YYYY-MM-DDTHH:mm:ssZZ');
}
